export const formatRelativeTime = (
    date: { toDate?: () => Date; seconds?: number } | null | undefined,
    timezone?: string
): string => {
    if (!date) return 'just now'
    const jsDate = date.toDate ? date.toDate() : new Date(date.seconds! * 1000)
    const now = new Date()
    const diffMs = now.getTime() - jsDate.getTime()
    const diffMins = Math.floor(diffMs / 60000)
    const diffHours = Math.floor(diffMs / 3600000)
    const diffDays = Math.floor(diffMs / 86400000)

    if (diffMins < 1) return 'just now'
    if (diffMins < 60) return `${diffMins}m ago`
    if (diffHours < 24) return `${diffHours}h ago`
    if (diffDays < 7) return `${diffDays}d ago`

    const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
    const opts: Intl.DateTimeFormatOptions = {
        month: 'short',
        day: 'numeric',
        timeZone: tz,
    }
    if (jsDate.getFullYear() !== now.getFullYear()) {
        opts.year = 'numeric'
    }
    return jsDate.toLocaleDateString('en-US', opts)
}
